import { OTHERS, SOCIAL_MEDIAS } from '../getRandomizedFindOutAlice'

const getFindOutAliceValue = ({
  findOutAliceSelect,
  socialMediaSelect,
  otherField
}: {
  findOutAliceSelect?: string
  socialMediaSelect?: string
  otherField?: string
}) => {
  if (findOutAliceSelect === OTHERS) return `Outros (${otherField})`
  if (findOutAliceSelect === SOCIAL_MEDIAS)
    return `Redes Sociais (${socialMediaSelect})`
  return findOutAliceSelect
}

export { getFindOutAliceValue }
